import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '~/views/Auth.vue'
import store from '~/store/index.js'
import {userCheckAccess} from '~/configs/methods'

import RouterViewBody from '~/views/RouterViewBody.vue'
import ViewsTemplateMain from '~/views/template/ViewsTemplateMain'
import ErrorPage from '~/views/error.vue'
import timeControlShowReportsViewSign from '~/views/sales/timeControl/timeControlShowReportsViewSign'

import routerSales from './modules/routerSales'
import routerFinance from './modules/routerFinance'
import routerProjects from './modules/routerProjects'
import routerSetting from './modules/setting/routerSetting'
import routerDocuments from './modules/routerDocuments'
import routerPersonnelDepartment from './modules/personnel-departmant/routerPersonnelDepartment'
import routerChat from './modules/routerChat'

Vue.use(VueRouter)

const formatDate = function (date) {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${day}.${month}.${year}`
}
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('../views/Auth.vue'),
      meta: {
        responsive: true,
      },
    },
    {
      path: '/confirm-email/:token?',
      name: 'ConfirmEmail',
      component: Auth,
      props: true,
      meta: {
        responsive: true,
      },
    },
    {
      path: '/confirm-restore/:token?',
      name: 'ConfirmRestore',
      component: Auth,
      props: true,
      meta: {
        responsive: true,
      },
    },
    
    {
      path: '/mobile',
      name: 'Mobile',
      component: ErrorPage, //Mobile,
      meta: {
        responsive: true,
      },
    },
    {
      path: '/report-sign/:hash',
      component: ViewsTemplateMain,
      meta: {
        responsive: true,
      },
      children: [
        {
          path: '',
          component: timeControlShowReportsViewSign,
          name: 'linkProjectReportSign',
          meta: {
            responsive: true,
            headerSecondDisable: true,
          },
        },
      ],
    },
    
    {
      path: '/',
      component: RouterViewBody,
      meta: {
        requiresAuth: true,
        responsive: true,
        breadCrumbLocalStorage: 'translations',
        breadCrumb: (translation) => translation.pages.pages.buttons.glavnaya,
      },
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('../views/Home.vue'),
          meta: {
            responsive: true,
          },
        },
        {
          path: '/first-auth',
          name: 'FirstAuth',
          component: Auth,
          meta: {
            responsive: true,
          },
        },
        ...routerChat,
        ...routerPersonnelDepartment,
        ...routerSales,
        ...routerFinance,
        ...routerProjects,
        {
          path: 'clients',
          name: 'clients',
          redirect: {
            name: 'clientsCompany',
          },
          component: () => import('~/views/template/ViewsTemplateMain.vue'),
          meta: {
            access: {abilities: ['view_clients']},
            responsive: true,
            breadCrumbLocalStorage: 'translations',
            breadCrumb: (translation) => translation.pages.pages.buttons.clients,
            headerSecondDisable: true,
          },
          children: [
            {
              path: 'company',
              redirect: {
                name: 'clientsCompany',
              },
              component: () => import('~/views/clients/clients.vue'),
              meta: {
                access: {abilities: ['view_clients']},
                breadCrumbLocalStorage: 'translations',
                breadCrumb: (translation) => translation.pages.pages.buttons.company,
              },
              children: [
                {
                  path: '',
                  name: 'clientsCompany',
                  component: () => import('~/views/clients/clientsList.vue'),
                  meta: {
                    responsive: true,
                    search: true,
                    headerSecondDisable: true,
                    paginations: {
                      page: 1,
                      limit: 10,
                    },
                  },
                },
                {
                  path: 'create',
                  name: 'clientsCompanyCreate',
                  component: () => import('~/views/clients/clientsCompany.vue'),
                  meta: {
                    responsive: true,
                    access: {abilities: ['edit_clients']},
                    breadCrumbLocalStorage: 'translations',
                    breadCrumb: (translation) => translation.pages['setting-client']['dialog-add_edit']['sozdanie-klienta'],
                  },
                },
                {
                  path: ':id',
                  name: 'clientsCompanyShow',
                  component: () => import('~/views/clients/clientsCompany.vue'),
                  meta: {
                    access: {abilities: ['view_clients']},
                    responsive: true,
                    breadCrumbGetter: 'workClient/workClientShow',
                    breadCrumb: (client) => client.name,
                    paginations: {
                      tab: 'offices',
                      subTab: 'current',
                      office_page: 1,
                      office_limit: 10,
                      address_page: 1,
                      address_limit: 10,
                      email_page: 1,
                      email_limit: 10,
                      phone_page: 1,
                      phone_limit: 10,
                      person_page: 1,
                      person_limit: 10,
                      grid: 'grid',
                      project_page: 1,
                      project_limit: 10,
                    },
                  },
                  children: [
                    {
                      path: 'edit',
                      name: 'clientsCompanyShowEdit',
                      component: () => import('~/views/clients/clientsCompany.vue'),
                      meta: {
                        access: {abilities: ['edit_clients']},
                        responsive: true,
                        paginations: {
                          tab: 'offices',
                          subTab: 'current',
                          office_page: 1,
                          office_limit: 10,
                          address_page: 1,
                          address_limit: 10,
                          email_page: 1,
                          email_limit: 10,
                          phone_page: 1,
                          phone_limit: 10,
                          person_page: 1,
                          person_limit: 10,
                          grid: 'grid',
                          project_page: 1,
                          project_limit: 10,
                        },
                      },
                    }
                  ]
                }
              ]
            },
            {
              path: 'company-sales',
              redirect: {
                name: 'clientsCompanySales',
              },
              component: () => import('~/views/clients/clients.vue'),
              meta: {
                access: {abilities: ['view_clients']},
                breadCrumbLocalStorage: 'translations',
                breadCrumb: (translation) => translation.pages.pages.buttons['company-sales'],
              },
              children: [
                {
                  path: '/',
                  name: 'clientsCompanySales',
                  component: () => import('~/views/clients/clientsList.vue'),
                  meta: {
                    responsive: true,
                    search: true,
                    headerSecondDisable: true,
                    paginations: {
                      page: 1,
                      limit: 10,
                    },
                  },
                },
                {
                  path: 'create',
                  name: 'clientsCompanySalesCreate',
                  component: () => import('~/views/clients/clientsCompanySales.vue'),
                  meta: {
                    responsive: true,
                    access: {abilities: ['edit_clients']},
                    breadCrumbLocalStorage: 'translations',
                    breadCrumb: (translation) => translation.pages['setting-client']['dialog-add_edit']['sozdanie-klienta'],
                  },
                },
                {
                  path: ':id',
                  name: 'clientsCompanySalesShow',
                  component: () => import('~/views/clients/clientsCompanySales.vue'),
                  meta: {
                    responsive: true,
                    access: {abilities: ['view_clients']},
                    breadCrumbGetter: 'workClientInvoicingCompany/workClientInvoicingCompanyShow',
                    breadCrumb: (client) => client.name,
                  },
                  children: [
                    {
                      path: 'edit',
                      name: 'clientsCompanySalesShowEdit',
                      component: () => import('~/views/clients/clientsCompanySales.vue'),
                      meta: {
                        access: {abilities: ['edit_clients']},
                        responsive: true,
                      },
                    }
                  ]
                }
              ]
            }
          ],
        },
        ...routerDocuments,
        ...routerSetting,
        {
          path: 'planning',
          name: 'Planning',
          component: () => import('../views/template/ViewsTemplateMain.vue'),
          props: {type: 'planning'},
          redirect: () => {
            return {
              name: userCheckAccess({
                abilities: 'view_orders_volume',
              })
                ? 'PlanningTableWork'
                : 'PlanningGeneralSchedule',
            }
          },
          meta: {
            responsive: true,
            breadCrumbLocalStorage: 'translations',
            breadCrumb: (translation) => translation.pages.pages.buttons.planirovanie,
          },
          children: [
            {
              path: 'volume-of-orders',
              name: 'PlanningTableWork',
              component: () => import('../views/planning/planningTableWork.vue'),
              meta: {
                responsive: true,
                breadCrumbLocalStorage: 'translations',
                breadCrumb: (translation) => translation.pages.planning.pages['obem-zakazov'],
                access: {abilities: ['view_orders_volume']},
              },
            },
            {
              path: 'general-schedule',
              name: 'PlanningGeneralSchedule',
              component: () => import('../views/planning/planningGeneralSchedule.vue'),
              meta: {
                breadCrumbLocalStorage: 'translations',
                breadCrumb: (translation) => translation.pages.planning.pages['obshchiy-grafik'],
                access: {abilities: ['view_general_schedule']},
              },
            },
          ],
        },
      ],
    },
    
    {
      path: '*',
      name: '404',
      component: ErrorPage,
    },
  ],
})

const isLoggedIn = store.getters['auth/isLoggedIn']

router.beforeEach(async (to, from, next) => {
  if (to.meta.paginations) {
    let local = localStorage.getItem('queryParams')
    local = local ? JSON.parse(localStorage.getItem('queryParams')) : {}
    let id = !!to.params.id ? String(to.params.id) : null
    for (let key in to.meta.paginations) {
      //if (!to.query[key]) {
      if (id) {
        to.query[key] = !!local[to.name] && !!local[to.name][id] ? local[to.name][id][key] : to.meta.paginations[key]
      } else {
        to.query[key] = !!local[to.name] ? local[to.name][key] : to.meta.paginations[key]
      }
      //}
    }
  }
  if (!isLoggedIn) {
    if (
      to.name !== 'ConfirmEmail' &&
      to.name !== 'ConfirmRestore' &&
      to.name !== 'linkProjectReportSign' &&
      to.name !== 'Login' &&
      to.name !== 'FirstAuth'
    ) {
      if (!store.state.pathAfterAuth) {
        store.state.pathAfterAuth = to.path
      }
    }
  }
  next()
})

export default router
